<adf-info-drawer-layout [showHeader]="showHeader">
  <div aria-level="1" *ngIf="title" info-drawer-title>
    {{ title | translate }}
  </div>
  <ng-content
    *ngIf="!title"
    info-drawer-title
    select="[info-drawer-title]"
  ></ng-content>

  <ng-content info-drawer-buttons select="[info-drawer-buttons]"></ng-content>

  <ng-container info-drawer-content #templateContainer></ng-container>

  <ng-template #tabLayout>
    <ng-container class="wk-tab-buttons" *ngIf="!isViewerMode">
      <button
        mat-flat-button
        *ngIf="canEditMetadata()"
        type="button"
        class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary mat-mdc-button-base"
        (click)="this.isEditModeChange.emit(true)"
      >
        {{ 'APP.INFO_DRAWER.BUTTON.EDIT' | translate }}
      </button>

      <button
        mat-flat-button
        *ngIf="isEditMode"
        type="button"
        class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary mat-mdc-button-base"
        (click)="cancelAllChanges()"
      >
        {{ 'APP.INFO_DRAWER.BUTTON.EXIT_EDITING' | translate }}
      </button>
    </ng-container>
    <mat-tab-group
      #tabGroup
      [(selectedIndex)]="selectedIndex"
      class="adf-info-drawer-tabs"
      [ngClass]="
        isEditMode
          ? 'adf-info-drawer-tabs_edit-mode'
          : 'adf-info-drawer-tabs_view-mode'
      "
      (selectedIndexChange)="onTabChange($event)"
      (animationDone)="onSelectedCitation()"
    >
      <mat-tab
        [disabled]="disabledStates[contentBlock.label] | async"
        *ngFor="let contentBlock of contentBlocks; let i = index"
        [disabled]="disabledStates[contentBlock.label] | async"
        [label]="contentBlock.label | translate"
        class="adf-info-drawer-tab"
      >
        <ng-template mat-tab-label>
          <mat-icon *ngIf="contentBlock.icon">{{ contentBlock.icon }}</mat-icon>
          <span
            acaTabsHoverAnimation
            [tabGroup]="tabGroup"
            [tabIndex]="i"
            *ngIf="contentBlock.label"
            [id]="i"
            >{{ contentBlock.label | translate }}</span
          >
        </ng-template>

        <ng-container *ngTemplateOutlet="contentBlock.content"></ng-container>
      </mat-tab>
    </mat-tab-group>
  </ng-template>

  <ng-template #singleLayout>
    <ng-content select="[info-drawer-content]"></ng-content>
  </ng-template>
</adf-info-drawer-layout>
